import { Component, computed } from '@angular/core';
import { AbbChartComponent } from '@components/abb-chart/abb-chart.component';
import { CustomWidget } from '../widget';
import { YAxis } from '@constants/widgets';

@Component({
  selector: 'abb-line-chart-widget',
  standalone: true,
  imports: [AbbChartComponent],
  template: `<abb-chart
    class="block"
    [yAxisLabel]="dataChart().label"
    [chartType]="'line'"
    [dataChart]="dataChart()"
    [grow]="true"
    [useCustomLabels]="false"
    [min]="chartMin()"
    [max]="chartMax()"
    [xAxisType]="xAxisType()"
    [xAxisLabels]="xLabels()"
  ></abb-chart> `,
  styles: ``,
  host: {
    class: 'h-full w-full block',
  },
})
export class LineChartWidgetComponent extends CustomWidget {
  yAxis = computed(() => this.widget().yAxis as YAxis);

  chartMin = computed(() =>
    this.yAxis() === YAxis.AUTOSCALE
      ? undefined
      : this.widget().min ?? undefined
  );
  chartMax = computed(() =>
    this.yAxis() === YAxis.AUTOSCALE
      ? undefined
      : this.widget().max ?? undefined
  );

  dataChart = computed(() => {
    const data = this.data();
    if (data && data.__typename === 'ChartData') {
      const chartSeries = {
        series: data.series.map(({ name, values }) => ({
          name,
          values: values.map(({ x, y }) => ({
            y,
            x: Number(x),
          })),
        })),
        label: data.label,
      };
      return chartSeries;
    }
    return { series: [], label: { text: '', unit: '' } };
  });

  xAxisType = computed(() => {
    const data = this.data();
    if (
      data &&
      data.__typename === 'ChartData' &&
      data.series?.[0]?.values?.some((value) => {
        let toDate = new Date(Number(value.x));
        return toDate instanceof Date && !isNaN(toDate.getTime());
      })
    ) {
      return 'time';
    }
    return 'category';
  });

  xLabels = computed(() => {
    const data = this.data();
    if (data && data.__typename === 'ChartData') {
      const labels =
        data.series && data.series?.length > 0
          ? data.series[0].values?.map((value) => {
              if (this.xAxisType() === 'time') {
                let toDate = new Date(Number(value.x));
                return toDate.toLocaleTimeString(navigator.language, {
                  hour: '2-digit',
                  minute: '2-digit',
                });
              }
              return value.x;
            })
          : [];
      return labels;
    }
    return undefined;
  });
}
